import { Component, OnInit, Input, ViewChild, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import _ from 'lodash';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

import { HouseStatusService } from '@root/router/deprecated_and_do_not_use-house/house-status/house-status.service';
import { HouseStatusSettingService } from '@root/router/setting/custom-config/house-status-setting.service';
import { OrderV2Service } from '@root/router/order-v2/order-v2.service';
// import { MAX_AMOUNT } from "@root/config";

@Component({
  selector: 'host-continue-stay',
  templateUrl: './continue-stay.component.html',
  styleUrls: ['./continue-stay.component.scss'],
})
export class ContinueStayComponent implements OnInit {
  @Input() reservation_code;
  @Input() type: 'single' | 'mass' = 'single';
  @ViewChild('paidAmountInput') paidAmountInput;
  form: UntypedFormGroup = this.fb.group({
    days: 1,
    needFee: [null, Validators.required],
    paid_amount: null,
    trade: 2, // 微信
  });
  payOptions = [];
  checking = false;
  // maxAmount = MAX_AMOUNT;

  constructor(
    private fb: UntypedFormBuilder,
    private orderService: OrderV2Service,
    private subject: NzModalRef,
    private houseStatusService: HouseStatusService,
    private houseStatusSettingService: HouseStatusSettingService,
    @Inject(NZ_MODAL_DATA) private modalData: { reservation_code: string; type: 'single' | 'mass' }
  ) {}

  ngOnInit() {
    /**
     * @compat 准备过度到v16
     */
    this.reservation_code = this.modalData.reservation_code;
    this.type = this.modalData.type;

    this.getOptions();
  }

  getOptions() {
    this.houseStatusSettingService.getSettings().subscribe((res) => {
      const data = _.get(res, 'data');
      this.payOptions = _.filter(_.get(data, 'income_method'), (item) => !item.delete_time);
    });
  }

  save() {
    this.checking = true;
    const valid = this.form.valid;
    if (!valid) {
      return;
    }
    const value = this.form.value;
    const params = {
      number: value.days,
      amount: value.needFee,
      paid_amount: value.paid_amount,
      payment_method: value.trade,
    };
    if (this.type === 'single') {
      _.assign(params, {
        reservation_code: this.reservation_code,
      });
    } else {
      _.assign(params, {
        reservation_order_code: this.reservation_code,
      });
    }
    this.orderService.expand(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.subject.destroy({
          refresh: true,
        });
      }
    });
  }

  cancel() {
    this.subject.destroy('onCancel');
  }

  // getCheckedChange() {
  //   _.delay(() => {
  //     const needFee = this.form.get('needFee').value;
  //     const checked = this.form.get('checked').value;
  //     if (checked) {
  //       this.form.patchValue({
  //         paid_amount: needFee
  //       });
  //       this.paidAmountInput.focus();
  //       this.paidAmountInput.inputElement.nativeElement.select();
  //     }
  //   }, 500);
  // }
}
